import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const MovRow = (props) => {
    let colorCode;
    if (props.tipo === 'COMPRA') colorCode = '#F4F9F5';
    if (props.tipo === 'VENDA') colorCode = '#FDF7F7';
    if (props.tipo === 'BONIF') colorCode = '#EFF8FB';

    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start" style={{ "backgroundColor": colorCode }}>
            <div className="row">
                <div className="col-10">
                    <div className="d-flex w-100 justify-content-between">
                        <small>{moment(props.data).format('DD/MM/YYYY')}</small>
                        <small>{props.quantidade}</small>
                        <small>{parseFloat(props.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                </div>
                <div className="col">
                    <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                        onClick={() => props.handleDelete(props.id)} />
                </div>
            </div>
        </li>
    );
};

MovRow.propTypes = {
    tipo: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    quantidade: PropTypes.string.isRequired,
    preco: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default MovRow;


// WEBPACK FOOTER //
// ./src/components/MovAtivo/MovRow.js